/** Shared SDS classification types (MSDS-2). Client + server. */

export const SDS_CLASSIFY_SUGGESTIONS = ["likely", "unlikely", "unknown"] as const;
export type SdsClassifySuggestion = (typeof SDS_CLASSIFY_SUGGESTIONS)[number];

export const SDS_CLASSIFY_CONFIDENCES = ["low", "medium", "high"] as const;
export type SdsClassifyConfidence = (typeof SDS_CLASSIFY_CONFIDENCES)[number];

export type SdsClassificationResult = {
  suggestion: SdsClassifySuggestion;
  confidence: SdsClassifyConfidence;
  reasoning: string;
  hazard_signals: string[];
};

export type ClassifySdsNeedInput = {
  name: string;
  category: string;
  unit?: string;
  vendor?: string;
  chemical_hints?: string;
};

export function isSdsClassifySuggestion(value: unknown): value is SdsClassifySuggestion {
  return typeof value === "string" && (SDS_CLASSIFY_SUGGESTIONS as readonly string[]).includes(value);
}

export function isSdsClassifyConfidence(value: unknown): value is SdsClassifyConfidence {
  return typeof value === "string" && (SDS_CLASSIFY_CONFIDENCES as readonly string[]).includes(value);
}

export function sdsSuggestionLabel(suggestion: SdsClassifySuggestion): string {
  switch (suggestion) {
    case "likely":
      return "Likely needs SDS";
    case "unlikely":
      return "Likely not needed";
    case "unknown":
    default:
      return "Unclear — decide manually";
  }
}

/** Map AI suggestion → radio default the operator can still override. */
export function msdsStatusFromSuggestion(
  suggestion: SdsClassifySuggestion
): "not_required" | "required" | "undecided" {
  switch (suggestion) {
    case "likely":
      return "required";
    case "unlikely":
      return "not_required";
    case "unknown":
    default:
      return "undecided";
  }
}
